<template>
  <v-container fluid grid-list-xl px-0 pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items >
        <v-btn icon to="/createPushNotification" title="Crear notificacion">
          <v-icon color="primary">fa fa-plus</v-icon>
        </v-btn>
        <v-btn icon disabled>
          <v-icon>more_vert</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-container fluid>
        <v-layout row wrap align-center justify-center fill-height>
          <v-flex lg6 xs2>
            <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
              <v-icon>cached</v-icon>
            </v-btn>
          </v-flex>
          <v-flex lg6 xs10 text-lg-right>
            <v-text-field
              style="padding:0px; margin:0px"
              id="searchBox"
              single-line
              v-model="searchValue"
              @keydown.enter="enter"
              @keydown.down="down"
              @keydown.up="up"
              placeholder="Buscar"
              append-icon="search"
              light
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider style="margin:0px"></v-divider>
      <v-card-text style="padding-top:0px">
        <v-data-table
          flat
          :headers="headers"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="pagination.rowsPerPageItems"
          :items="pushNotificationPaging"
          class="v-table-list theme--light"
        >
          <template slot="headers" scope="props">
            <tr class="border-buttom">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                {{ header.text }}
                <v-icon>arrow_upward</v-icon>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left cut-text">{{ props.item.title }}</td>
            <td class="text-xs-left cut-text">{{ props.item.description }}</td>
            <td class="text-xs-left cut-text">
              <a
                :href="props.item.imageUrl"
                target="_blank"
                class="text-truncate"
              >{{ props.item.imageUrl.substring(props.item.imageUrl.lastIndexOf('/'), props.item.imageUrl.lenght)}}</a>
            </td>
            <td class="text-xs-left cut-text">{{ nzDate(props.item.modificationDate) }}</td>
          </template>
          <template slot="no-data">
            <div>{{$t('message.noNotifications')}}</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  computed: {
    ...mapGetters(["loadingNotifications", "agency"]),
    pagination: {
      get: function() {
        return this.$store.getters.paginationPushNotification;
      },
      set: function(value) {
        this.$store.commit("setPaginationPushNotification", value);
      }
    },
    pushNotificationPaging() {
      return this.$store.getters.pushNotificationPaging;
    }
  },
  mounted() {
    this.$store.dispatch("getNotifications", this.searchValue);
  },
  methods: {
    nzDate: nzDate,
    enter() {
      this.$store.dispatch("getNotifications", this.searchValue);
    },
    refresh() {
      this.$store.dispatch("getNotifications", this.searchValue);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  watch: {
    pagination: {
      handler() {
        this.$store.dispatch("getNotifications", this.searchValue);
      },
      deep: true
    },
    loadingNotifications(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando notificaciones");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getNotifications", this.searchValue);
    }
  },
  data() {
    return {
      searchValue: "",
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.title"),
          value: "title",
          width: "3%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.description"),
          value: "description",
          width: "5%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.image"),
          value: "imageUrl",
          width: "2%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.sendDate"),
          value: "modificationDate",
          width: "2%"
        }
      ]
    };
  }
};
</script>